//Loop2 body content
import { ChevronRight } from 'lucide-react'
import './loopview.css'
import { useNavigate } from 'react-router-dom'

const LoopNinebody = ({ data, setNextStep, subject, articles }) => {
  const navigate = useNavigate()
  const getexpertsbysubject = subject => {
    navigate('/HomeScreen', { state: { selectedSubject: subject } })
  }
  // const handleReadArticle = () => {
  //   const firstArticle = articles?.[0]
  //   if (firstArticle) {
  //     window.open(firstArticle.articleUrl, '_blank')
  //   } else {
  //     console.warn('No article found for subject:', subject)
  //   }
  // }

    const token = sessionStorage.getItem("token");

  const handleReadArticle = async () => {
  try {

    const myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
    const response = await fetch(
      "https://learnatrecess.com:7001/getAllSubject",
      requestOptions
    );

    const result = await response.json();
    const allArticles = result?.data || [];

    console.log("All Articles:", allArticles);

    // Find articles matching the subject
    const matched = allArticles.filter(
      (a) =>
        a.subject?.toLowerCase() === subject?.toLowerCase()
    );

    if (matched.length === 0) {
      console.warn("No article found for subject:", subject);
      return;
    }

    const firstArticle = matched[0];
    console.log("First Matched Article:", firstArticle);

    if (firstArticle.guide_url) {
      window.open(firstArticle.guide_url, "_blank");
    } else {
      console.warn("Article URL missing for:", firstArticle.guide_url);
    }
  } catch (error) {
    console.error("Error fetching articles:", error);
  }
};


  return (
    <div>
      <h5 className='title'>
        {data.TitleName.split('\n').map((line, index) => (
          <div key={index} className='title-line'>
            {line}
          </div>
        ))}
      </h5>

      <p className='bodytext1'>{data.bodytext1}</p>
      <p className='bodytext2'>{data.bodytext2}</p>

      <div className='skills-container mt-16'>
        <span onClick={handleReadArticle} className='tag btn'>
          Read Article <ChevronRight className='inline size-5' />
        </span>

        <span
          onClick={e => {
            e.stopPropagation()
            console.log('Loop Subject:', subject)
            getexpertsbysubject(subject)
          }}
          className='tag btn'
        >
          Speak to an Expert <ChevronRight className='inline size-5' />
        </span>
      </div>
    </div>
  )
}

export default LoopNinebody

{
  /* <span onClick={() => setNextStep('Practice')} className='tag btn'>
          Speak to an Expert <ChevronRight className='inline size-5' />
        </span> */
}
//  <span onClick={() => setNextStep('Read')} className='tag btn'>
//         Read Article <ChevronRight className='inline size-5' />
//       </span>
